import { IEntity, IPagedSearchParams } from '@pf/shared-common';
import {
    CustomFieldViewModel,
    ItemFragment,
    PickFragment,
    ProjectLineItemSearchRequestParams,
    ProjectLineItemViewModelCreateBody,
    ProjectLineItemViewModelRead,
    ProjectStatus,
    ResourceAuth,
} from '@control-tower/platform-wms';

export type ProjectLineItemRead = ProjectLineItemViewModelRead & IEntity;
export type ProjectLineItemCreate = ProjectLineItemViewModelCreateBody;
export type ProjectLineItemSearchParams = ProjectLineItemSearchRequestParams &
    IPagedSearchParams;

export class ProjectLineItemDto implements IEntity {
    constructor(data: Partial<ProjectLineItemDto>) {
        Object.assign(this, data);
    }
    id!: string;
    projectId!: string;
    lineNumber!: number;
    quantity!: number;
    unitOfMeasure!: string;
    status!: ProjectStatus;
    notes?: string | null;
    startDate?: string | null;
    endDate?: string | null;
    item?: ItemFragment;
    pick?: PickFragment;
    isDeleted?: boolean;
    createdDate?: string;
    modifiedDate?: string;
    customFields?: Array<CustomFieldViewModel> | null;
    resourceAuth?: ResourceAuth;
}
